import React, { useEffect, useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../../providers/auth_provider'
import { useSnackBar } from '../../providers/snack_bar_provider'
import {
  getAppClient,
  handleError,
  ApiErrorResponse,
} from '../../utils/network_util'

/**
 * ダッシュボードからの認証付き遷移を処理するページ
 */
const TokenExchangePage: React.FC = () => {
  const navigate = useNavigate()
  const { signIn } = useContext(AuthContext)
  const { showSnackBar } = useSnackBar()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    exchangeToken()
  }, [])

  const exchangeToken = async () => {
    // URLパラメータからトークン情報を取得
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    const key = params.get('key')
    const userId = params.get('user_id')

    // パラメータが不足している場合はエラー
    if (!token || !key || !userId) {
      setError(
        '認証情報が不足しています。ダッシュボードから再度お試しください。'
      )
      return
    }

    try {
      // APIでトークンを交換
      const api = getAppClient()
      const response = await api.auth.loginTokenCreate({
        token,
        key,
        userId: userId,
      })

      // ログイン処理
      signIn(response.data.user, response.data.token)

      // 成功メッセージを表示してホームへリダイレクト
      navigate('/')
    } catch (e) {
      const apiError = e as ApiErrorResponse
      handleError(apiError, showSnackBar)
      setError(
        '認証に失敗しました。トークンの有効期限が切れている可能性があります。'
      )
    }
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        {error ? (
          <div className="bg-white p-8 rounded-lg shadow-md">
            <p className="text-red-600 mb-4">{error}</p>
            <button
              onClick={() => navigate('/login')}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              ログインページへ
            </button>
          </div>
        ) : (
          <div className="bg-white p-8 rounded-lg shadow-md">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
            <p className="text-gray-600">認証処理中...</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default TokenExchangePage
